import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Sirve para cualquier industria?',
  a: 'Sí. Hay plantillas y ejemplos para marketing, finanzas, IT, RRHH, ventas, logística, administración y salud. Para todos los niveles: junior a ejecutivo.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'En menos de 5 minutos después de la compra recibís el acceso por mail. Todo listo para usar.'
}, {
  q: '¿Funciona si tengo brecha laboral o cambio de carrera?',
  a: 'Sí. El sistema incluye estrategias específicas para ambas situaciones en múltiples tomos y bonos.'
}, {
  q: '¿Tiene garantía real?',
  a: '7 días de garantía total. Sin preguntas. 100% del dinero de vuelta si no es lo que esperabas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-[#112240]/30 border-t border-slate-800/50" data-id="element-85">
      <div className="max-w-3xl mx-auto" data-id="element-86">
        <h2 className="text-3xl font-bold text-white mb-10 text-center flex items-center justify-center gap-3" data-id="element-87">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-88">
          {faqs.map((faq, i) => <div key={i} className={`border rounded-xl overflow-hidden transition-colors ${openIndex === i ? 'border-[#d4a843]/50 bg-[#112240]' : 'border-slate-700 bg-[#0a1628] hover:border-slate-500'}`} data-id="element-89">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-90">
                <span className="font-bold text-white text-lg pr-4" data-id="element-91">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-[#d4a843] transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-92" />
              </button>

              <AnimatePresence data-id="element-93">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-94">
                    <div className="px-6 pb-5 text-slate-300 leading-relaxed" data-id="element-95">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}